import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next';
import { ButtonGroup, Button, Card, CardHeader, CardFooter, CardBody, CardTitle } from 'reactstrap';
import { Link } from "react-router-dom";
import { CourseListItem, PageTitle } from '../../../components';
import { downloadRollCallPdf } from '../../../redux/modules';
import { loadCourses } from '../../../redux/modules';

import './CoursesList.css';

import Icon from '@mdi/react';
import {
    mdiCalendarBlankOutline,
    mdiAccountGroupOutline,
    mdiFileDownloadOutline,
    mdiRoomServiceOutline,
    mdiCastEducation
} from '@mdi/js';


const CoursesList = props => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(loadCourses({
            'from_last_week': true,
            'not_after_today': true
        }));
    }, [])

    const { t } = useTranslation();
    const {
        courses,
        inactive_courses,
        hasLoadingError,
        loadingErrorMessage
    } = useSelector(state => state.courses);

    const downloadRollCall = (group) => {
        dispatch(downloadRollCallPdf(group));
    }

    const coursesMap = React.useMemo(() => {
        const map = {};

        if (!courses)
            return map;

        courses?.forEach(course => {
            const day = course.start_at.format('dddd D MMM');
            if (!(day in map))
                map[day] = {};

            const group = course.classroom.group;
            if (!(group?.name in map[day]))
                map[day][group?.name] = [];

            map[day][group?.name].push(course);
        });

        return map;
    }, [courses]);

    return (
        <div className="CoursesList">
            <PageTitle icon={mdiCastEducation} title={t('courses.course_plural')} />
            {Object.keys(coursesMap).map(day => (
            <>
                <PageTitle icon={mdiCalendarBlankOutline} title={day} tag="h4" />
                <div className="ms-3 mb-5">
                    {Object.keys(coursesMap[day]).map(group => (
                        <>
                            <CardTitle tag="h5" className="ms-3 mb-1">
                                <Icon path={mdiAccountGroupOutline} size={1} />&nbsp;
                                {group}
                            </CardTitle>
                            <Card color="light" className="ms-3 mb-3">
                                <CardBody>
                                {coursesMap[day][group].map(course => (
                                    <CourseListItem
                                        course={course}
                                        hideDay
                                    />
                                ))}
                                </CardBody>
                                <CardFooter>
                                    <ButtonGroup className="pull-right">
                                        <Button onClick={ () => downloadRollCall(coursesMap[day][group][0].classroom.group) } color="info">
                                            <Icon path={mdiFileDownloadOutline} size={1} />&nbsp;
                                            { t('groups.download_roll_call_pdf') }
                                        </Button>
                                        {coursesMap[day][group][0].canBeRollCalled() && (
                                        <Button className="ms-2 text-white" tag={Link} to={`/courses/edit/${coursesMap[day][group][0].id}`} color="success">
                                            <Icon path={mdiRoomServiceOutline} size={1} />&nbsp;
                                            {t('courses.make_rollcall')}
                                        </Button>
                                        )}
                                    </ButtonGroup>
                                </CardFooter>
                            </Card>
                        </>
                    ))}
                </div>
            </>
            ))}
        </div>
    );
}

export default CoursesList;
